import React from "react";
import { Helmet } from "react-helmet-async";
import TopBannerBn from "../top-banner-bn";
import CounterSectionBn from "../CounterSectionBn";
import TutorComponentBn from "../TutorComponentBn";
import RatingComponent from "../RatingComponent";
import TestimonialsBn from "../TestimonialBn";
import FooterBn from "../FooterBn";

const HomePageBn = () => {
  const canonicalUrl = "https://goatteachers.com/";
  const title =
    "Goat Teachers Bangladesh | Private Tuition, Home Tutors, Student Support";
  const description =
    "Goat Teachers is a Bangladesh edtech platform for private tuition, home tutors, tutor discovery, and student support. Find tutors or post tuition needs easily.";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Goat Teachers",
    url: canonicalUrl,
    logo: "https://goatteachers.com/logo.png",
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Goat Teachers",
    url: canonicalUrl,
  };

  return (
    <>
      <Helmet>
        <html lang="bn" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="index,follow,max-image-preview:large" />
        <link rel="canonical" href={canonicalUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Goat Teachers" />
        <meta property="og:locale" content="bn_BD" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://goatteachers.com/og-home.jpg"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta
          name="twitter:image"
          content="https://goatteachers.com/og-home.jpg"
        />

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
      </Helmet>

      <main>
        <TopBannerBn />
        <CounterSectionBn />
        <RatingComponent />
        <TutorComponentBn />
        <TestimonialsBn />
      </main>

      <FooterBn />
    </>
  );
};

export default HomePageBn;
